setTimeout(function() {
    let baitDiv = document.querySelector('.AdsBox');

    if (baitDiv && window.getComputedStyle(baitDiv).getPropertyValue(
        'visibility') === 'visible') {
        baitDiv.remove();
    } else {
        let adblockNotification = document.createElement('div');
        adblockNotification.innerHTML = '<div class="adblock-notification__box"><span class="icon-simple-exclamation-mark-circle"></span>' +
            '<span class="icon-cross evt-cross-close-adblock-notification"></span><p class="adblock-notification__title">AdBlock Detected!</p>' +
            '<p class="adblock-notification__text">To unlock all bonuses and take advantage of the full functionality' +
            ' of the Bojoko site, we recommend turning off your AdBlocker.</p></div>';
        adblockNotification.className = 'adblock-notification';
        document.body.insertBefore(adblockNotification, document.body.firstChild);

        let closeButton = adblockNotification.querySelector('.evt-cross-close-adblock-notification');
        if (closeButton) {
            closeButton.addEventListener('click', function() {
                adblockNotification.remove();
            });
        }

        if (baitDiv) {
            baitDiv.remove();
        }
    }
}, 1000);